import { X } from "lucide-react";

function SpeechControlsActivation({
  isSessionActive,
  onStopSession,
  error,
  secondsRef
}) {
  const isOutOfMinutes = secondsRef?.current <= 0;

  // Don't show controls if out of minutes or there's an error
  if (isOutOfMinutes || error) {
    return null;
  }

  return (
    <div className="coaching-speech-controls-container">
      <div className="coaching-speech-controls">
        <div className="coaching-speech-controls-top">
          {isSessionActive && (
            <div className="coaching-mic-container">
              <div 
                className="coaching-mic active-session"
                onClick={onStopSession}
                style={{
                  backgroundColor: '#ff4444',
                  cursor: 'pointer'
                }}
              >
                <X size={24} color="white" />
              </div>
              <div className="coaching-speech-controls-bottom">
                <p className="speak-text">Close Session</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SpeechControlsActivation;
